/**
 * 只有这里允许写平台相关代码
 */

import config from "config";
import { ReceiverType } from "./types";
import { uploadToQiNiu } from "service/service";
import Storage from "../../utils/Storage";

// Storage
export const getUserNo = () => Storage.get<string>("teacherNo") || "";
export const getUserName = () => Storage.get<string>("teacherName") || "";

// Config
export const ApiHost = config.WsHost;

const wsHost = ApiHost.split("//").pop();
const protocol = window.location.protocol === "http:" ? "ws:" : "wss:";
export const getSocketUrl = () =>
    `${protocol}//${wsHost}teacher/websocket/${getUserNo()}/chat/STU_TO_TEA`;

export const CurrentUserType = ReceiverType.Teacher;
export const OppositeUserType = ReceiverType.Student;

export const customerCode = config.CustomCode;

// Utils

export { errorMessage, humanFileSize, isTrue } from "service/service";
export { default as useRequest } from "utils/useRequest";
export { default as useRequestFn } from "utils/useRequestFn";
export { FormatTime, getStrBySlice } from "utils/common";

export const useDeviceType = () => {
    return { isPC: true, isMobile: false };
};

export { default as useWebsocket } from "utils/useWebsocket";
export { default as useModalHandler } from "utils/useModalHandler";

// Components
export { ResultMessage } from "components/ResultMessage";
export { default as CustomEmpty } from "components/CourseComponents/CustomEmpty";

// APIs
export {
    deleteMessage,
    getCourseList,
    SessionType,
    closeSession,
    closeSessionBatch,
    getContactList,
    getSessionList,
    openSession,
    setHasRead,
    findHistoryMsg,
    getSessionInfo
} from "service/chat";

export { CourseWareTypeList } from "utils/common";

// 教师端于学生端的上传参数不一致, 这里做个polyfill
const uploadToQiNiuPolyfill = async (
    file: File,
    options: {
        onUploadProgress: (file: File, percent: number) => void;
    }
) => {
    return uploadToQiNiu(file, {
        onUploadProgress: percent => options.onUploadProgress(file, percent)
    });
};

export { uploadToQiNiuPolyfill as uploadToQiNiu };

export { getToken } from "service/service";
